import { render } from "./modalSucesso.vue?vue&type=template&id=e18b3032"
import script from "./modalSucesso.vue?vue&type=script&lang=js"
export * from "./modalSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__